import axios from '@/axios';

const RESOURCE_NAME = '/needs';

export default {
    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    saveNeed(id, data) {
        return axios.post(`${RESOURCE_NAME}/save-need?id=${id}`, data)
    },

    getWorkStatus(id) {
        return axios.get(`${RESOURCE_NAME}/get-work-status?id=${id}`)
    },

    getActivities(id) {
        return axios.get(`${RESOURCE_NAME}/get-activities?id=${id}`)
    },

    sendUpgradeRequest(id, data) {
        return axios.post(`${RESOURCE_NAME}/send-upgrade-request?id=${id}`, data)
    },

    setEcosystemsVisibility(id, value) {
        return axios.post(`${RESOURCE_NAME}/set-ecosystems-visibility?id=${id}`, {value})
    },

    escalate(id, data) {
        return axios.post(`${RESOURCE_NAME}/escalate?id=${id}`, data)
    },

    getReport(id) {
        return axios.get(`${RESOURCE_NAME}/get-report`, {
            params: { id, _: Date.now() },
            responseType: 'blob',
        })
    },

    setStatus(id, status) {
        return axios.post(`${RESOURCE_NAME}/set-status?id=${id}`, {status});
    },

    convert(id) {
        return axios.post(`${RESOURCE_NAME}/convert?id=${id}`);
    },

    nudge(id) {
        return axios.post(`${RESOURCE_NAME}/nudge?id=${id}`);
    },

    populateStartupsScores(id) {
        return axios.post(`${RESOURCE_NAME}/populate-startups-scores?id=${id}`);
    },

    updateKeywords(id) {
        return axios.post(`${RESOURCE_NAME}/update-keywords?id=${id}`)
    },
}
